// Shared constants and utilities for Admin components
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const productCategories = ['apparel', 'plushie', 'supplement'];
export const videoCategories = ['news', 'music', 'fairytale', 'courses'];
export const articleCategories = ['update', 'announcement', 'behind-the-scenes', 'rap'];

export const extractVideoId = (url) => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/,
    /^([a-zA-Z0-9_-]{11})$/
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return url;
};
